import ClientStorage from './ClientStorage';

export default ClientStorage;
